/**
 * @Author ZhangYing
 * @Date 2022-05-18 21:26:29
 * @LastEditors ZhangYing
 * @LastEditTime 2023-01-13 14:53:15
 * @Description
 * @FilePath /BM-Main/src/utils/http.js
 * @props
 */
import { catchErrSendLego } from '@/utils/helper'
import { judgeT } from '@/utils/judgeT'
import Login from '@/utils/login.js'
import zzfetch from '@zz/fetch'

const opts = {
  method: 'get',
  timeout: 20000
}

const methods = ['get', 'head', 'options', 'delete', 'post', 'put', 'patch', 'jsonp']

const http = {}

methods.forEach((method) => {
  http[method] = function(
    url,
    params,
    data,
    cancelType = 1,
    needLogin = false,
    withCredentials = true
  ) {
    const { format } = data || {}
    let options = Object.assign({}, opts, { url, params, method, cancelType, withCredentials })
    if (format) {
      options = Object.assign({}, options, { format })
    }

    return new Promise((resolve, reject) => {
      judgeT(url)
      zzfetch(options)
        .then((res) => {
          if (data && data.allData) resolve(res)
          const { respCode, respData } = res
          if (respCode == 0) {
            // 调接口成功，但是没有数据，上报lego
            !respData &&
              catchErrSendLego('call-api-suc-nodata', {
                api: url,
                params,
                respCode,
                respData
              })
            resolve(respData)
          } else if ((respCode == -2 || respCode == -8) && needLogin) {
            resolve(Login())
          } else if ((respCode == -100100)) {
            // 强调型错误提示文案 code码 = -100100
            const { errMsg, errorMsg } = res || {}
            const info = { dialogMsg: errMsg || errorMsg, errMsg, errorMsg }
            reject(info)
          } else {
            reject(res)
          }
        })
        .catch((err) => {
          // 调接口失败，上报下数据，上报lego
          catchErrSendLego('call-api-fail', {
            api: url,
            params,
            err
          })
          // 连续多次的请求会被取消，从而会出现预期之外的 catch 反馈，故 return 掉
          if (err?.type == 'Cancel') return
          reject(err)
        })
    })
  }
})

export default http
